
//32
Object.defineProperty(exports, "__esModule", { value: true });
require("./Button.st.css");
module.exports.default = require("stylable/runtime").create(
    "root",
    "ButtonStyle3334820286",
    {"root":"ButtonStyle3334820286--root","height":"initial","padding":"0px 23px","borderRadius":"0","fontFamily":"\"HelveticaNeueW01-45Ligh\", \"HelveticaNeueW02-45Ligh\", \"HelveticaNeueW10-45Ligh\", \"Helvetica Neue\", \"Helvetica\", \"Arial\", \"メイリオ; meiryo\", \"ヒラギノ角ゴ pro w3\", \"hiragino kaku gothic pro\", \"sans-serif\"","fontSize":"16px","lineHeight":"24px","fontStyle":"normal","fontWeight":"normal","color":"black","backgroundColor":"grey","borderColor":"black","disabledBackgroundColor":"black","disabledBorderColor":"grey","disabledColor":"grey"},
    null,
    module.id
);



//////////////////
// WEBPACK FOOTER
// ../node_modules/wix-ui-core/dist/src/components/deprecated/button/ButtonStyle.st.css
// module id = 1302
// module chunks = 0